<template>
    <modal :show="showModal" @close="closeModal">
        <div class="invite-modal">
            <h2>Edit your Housemate details</h2>

            <div class="input-block">
                <label for="first-name">First Name</label>
                <input type="text" name="first_name" id="first-name" placeholder="e.g. John" maxlength="50" v-model="fields.first_name">
                <span class="input-requirement error" v-text="errors.get('first_name')"></span>
            </div>

            <div class="input-block">
                <label for="last-name">Last Name</label>
                <input type="text" name="last_name" id="last-name" placeholder="e.g. Smith" maxlength="50" v-model="fields.last_name">
                <span class="input-requirement error" v-text="errors.get('last_name')"></span>
            </div>

            <div class="input-block">
                <label for="national-number">Mobile Number</label>
                <telephone-input v-model="fields.phone_number" placeholder="e.g. 7700 900123"></telephone-input>
                <span class="input-requirement error" v-text="errors.get('phone_number')"></span>
            </div>

            <div class="error-box" v-if="errors.has('error_box')" v-text="errors.get('error_box')">Test</div>

            <button type="button" class="btn btn-primary"  :disabled="disabled" @click="submitForm">Resend Invite</button>

        </div>
    </modal>
</template>

<script>
    import store from "../../../store/index";
    import Errors from '../../../helpers/Errors';

    import Modal from '../../Modal';
    import TelephoneInput from "../../telephoneinput/TelephoneInput";

    export default {
        name: "SuccessModal.vue",

        components: {
            Modal,
            TelephoneInput
        },

        data() {
            return {
                fields : {
                    id: '',
                    first_name : '',
                    last_name : '',
                    phone_number: {
                        country_code: '',
                        national_number: ''
                    },
                },
                errors: new Errors(),
                disabled: false
            }
        },

        mounted() {
            this.$store.watch((state) => state.success.activeInvite, (index) => {
                if(index !== null) {
                    this.loadInvite();
                }
            })
        },

        methods: {
            closeModal() {
                store.commit('success/hideInviteModal');
            },

            loadInvite() {
                let current = this.$store.getters['success/getActiveInvite'];

                if(!_.isEmpty(current)) {
                    this.$data.fields = _.cloneDeep(current);
                }

                this.errors.wipe();
            },

            handleSuccess(response) {
                store.commit('success/updateInvite', response.data.model);
                this.closeModal();
            },

            submitForm() {
                if(this.disabled) {
                    return;
                }

                this.disabled = true;

                // Reset errors
                this.errors.wipe();

                // Send Request
                axios.patch('', this.$data.fields).then(
                    response => this.handleSuccess(response)
                ).catch(
                    error => this.handleError(error)
                ).finally(
                    ()  => this.disabled = false
                );

            },

            handleError(error) {
                // TODO: Extract to mixin, add error message bag parameter
                if(error.response) {

                    switch(error.response.status) {
                        case 422:
                            // Unprocessable Entity
                            this.errors.record(error.response.data.errors);
                            break;
                        case 429:
                            // Too many requests
                            this.errors.create('error_box', 'Too many requests: Please wait and try again later');
                            break;
                        case 500:
                            // Internal server error
                            this.errors.create('error_box' , 'Unexpected error: Please contact support');
                            break;

                   }
                } else if(error.request) {
                    // Server not responding
                    this.errors.create('error_box' , 'Cannot connect to server');
                }

                // Update to register errors
                this.$forceUpdate();
            }
        },

        computed: {
            showModal() {
                return this.$store.getters['success/getShowInviteModal'];
            },

            phone() {
                return '+' + this.fields.phone_number.country_code + this.fields.phone_number.national_number;
            }
        }
    }
</script>